import React, { useState, useEffect } from 'react';
import Select from '../../../components/ui/Select';
import { adminService } from '../../../services/adminService';

const CountryCurrencySelector = ({ formData, errors, onChange }) => {
  const [countries, setCountries] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    setLoading(true);
    try {
      const [countriesRes, currenciesRes] = await Promise.all([
        adminService?.getSupportedCountries(),
        adminService?.getSupportedCurrencies()
      ]);

      setCountries(countriesRes?.data || []);
      setCurrencies(currenciesRes?.data || []);
    } catch (err) {
      console.error('Failed to load settings:', err);
      // Fallback to default values
      setCountries([
        { value: 'ie', label: 'Ireland' },
//        { value: 'uk', label: 'United Kingdom' },
//        { value: 'ca', label: 'Canada' },
//        { value: 'au', label: 'Australia' }
      ]);
      setCurrencies([
//        { value: 'usd', label: 'USD - US Dollar ($)' },
//        { value: 'gbp', label: 'GBP - British Pound (£)' },
        { value: 'eur', label: 'EUR - Euro (€)' },
//        { value: 'cad', label: 'CAD - Canadian Dollar (C$)' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleCountryChange = (value) => {
    onChange({ target: { name: 'country', value } });
  };

  const handleCurrencyChange = (value) => {
    onChange({ target: { name: 'currency', value } });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Select
        label="Country"
        options={countries}
        value={formData?.country}
        onChange={handleCountryChange}
        error={errors?.country}
        required
        searchable
        placeholder={loading ? 'Loading...' : 'Select your country'}
        disabled={loading}
      />
      <Select
        label="Preferred Currency"
        options={currencies}
        value={formData?.currency}
        onChange={handleCurrencyChange}
        error={errors?.currency}
        required
        searchable
        placeholder={loading ? 'Loading...' : 'Select currency'}
        description="Used for pricing and payments"
        disabled={loading}
      />
    </div>
  );
};

export default CountryCurrencySelector;